import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import {Validators, FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'page-visitors-reg-more',
  templateUrl: 'visitors-reg-more.html'
})
export class VisitorsRegMorePage {
  private vistor_reg1 : FormGroup;

  
  validation_messages = {
    'carreg': [
      { type: 'required', message: '*Please enter a name.' },
      //{ type: 'pattern', message: '*Please enter characters.' }
    ],
    'carmodel': [
      { type: 'required', message: '*Please enter a surname.' },
    ],
    'company': [
      { type: 'required', message: '*Please enter a id number.' },
    ],      
  }

  constructor( private formBuilder: FormBuilder, public navCtrl: NavController, public navParams: NavParams ) {
    this.vistor_reg1 = this.formBuilder.group({
      carreg: ['', Validators.required],
      carmodel: ['', Validators.required],
      company: ['', Validators.required]
    });
  }

  regForm1(){
    console.log(this.vistor_reg1.value);
  }
}



// WEBPACK FOOTER //
// ./src/pages/visitors-reg-more/visitors-reg-more.ts